import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  annotations: {
    id: 'studio.c2l+EP',
    defaultMessage: 'Annotations',
  },
  editButton: {
    id: 'studio.Z/1udv',
    defaultMessage: 'Edit group',
  },
  groupMembers: {
    id: 'studio.fT7nDJ',
    defaultMessage: 'Group members',
  },
  cancelLabel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  editingGroup: {
    id: 'studio.yUlBzE',
    defaultMessage: 'Editing group',
  },
  groupName: {
    id: 'studio.gL86bv',
    defaultMessage: 'Group name',
  },
  name: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  email: {
    id: 'studio.sy+pv5',
    defaultMessage: 'Email',
  },
  actions: {
    id: 'studio.wL7VAE',
    defaultMessage: 'Actions',
  },
  addMember: {
    id: 'studio.HFw+a8',
    defaultMessage: 'Add member',
  },
  noMembers: {
    id: 'studio.Lb1P34',
    defaultMessage: 'This group currently has no members.',
  },
  memberError: {
    id: 'studio.lCX8ty',
    defaultMessage: 'There was a problem loading this group’s members.',
  },
  loadingMembers: {
    id: 'studio.Lxkny3',
    defaultMessage: 'Loading members…',
  },
  noGroup: {
    id: 'studio.kvrEcW',
    defaultMessage: 'This group could not be found.',
  },
  groupError: {
    id: 'studio.l2htNZ',
    defaultMessage: 'There was a problem loading this group.',
  },
  loadingGroup: {
    id: 'studio.t4HlYe',
    defaultMessage: 'Loading group…',
  },
  deletingGroup: {
    id: 'studio.Ph66vC',
    defaultMessage: 'Deleting group',
  },
  deleteWarning: {
    id: 'studio.veYfyC',
    defaultMessage: 'Are you sure you want to delete this group? This action cannot be undone.',
  },
  deleteGroup: {
    id: 'studio.BpuMwR',
    defaultMessage: 'Delete group',
  },
});
